export const prepareWindowVariable = () => {
  window.echotex = { ...window.window.echotex, clients: window.window.echotex?.clients ?? {} };
};
